<template>
  <svg
    class="layout-type-icon"
    viewBox="0 0 20 36"
    aria-hidden="true"
    focusable="false"
  >
    <rect
      x="1"
      y="1"
      width="18"
      height="34"
      rx="3"
      fill="none"
      stroke="currentColor"
      stroke-width="1.2"
      opacity="0.45"
    />

    <template v-if="normalizedType === 'just_chatting'">
      <rect
        x="4"
        y="7"
        width="12"
        height="22"
        rx="1.2"
        fill="currentColor"
        opacity="0.9"
      />
    </template>

    <template v-else-if="normalizedType === 'gameplay'">
      <rect
        x="6"
        y="4.5"
        width="8"
        height="6"
        rx="1"
        fill="currentColor"
        opacity="0.95"
      />
      <rect
        x="3"
        y="12.5"
        width="14"
        height="19"
        rx="1.2"
        fill="currentColor"
        opacity="0.55"
      />
    </template>

    <template v-else-if="normalizedType === 'podcast'">
      <rect
        x="2.5"
        y="2.5"
        width="7"
        height="15"
        rx="0.8"
        fill="currentColor"
        opacity="0.9"
      />
      <rect
        x="10.5"
        y="2.5"
        width="7"
        height="15"
        rx="0.8"
        fill="currentColor"
        opacity="0.9"
      />
      <rect
        x="2.5"
        y="18.5"
        width="7"
        height="15"
        rx="0.8"
        fill="currentColor"
        opacity="0.75"
      />
      <rect
        x="10.5"
        y="18.5"
        width="7"
        height="15"
        rx="0.8"
        fill="currentColor"
        opacity="0.75"
      />
    </template>

    <template v-else-if="normalizedType === 'irl'">
      <rect
        x="2"
        y="2"
        width="16"
        height="32"
        rx="2"
        fill="currentColor"
        opacity="0.18"
      />
      <rect
        x="2"
        y="12.5"
        width="16"
        height="11"
        rx="1"
        fill="currentColor"
        opacity="0.92"
      />
    </template>
  </svg>
</template>

<script>
const KNOWN_LAYOUT_TYPES = new Set(["just_chatting", "gameplay", "podcast", "irl"]);

export default {
  name: "LayoutTypeIcon",
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    normalizedType() {
      const value = String(this.type || "").trim().toLowerCase();
      return KNOWN_LAYOUT_TYPES.has(value) ? value : "just_chatting";
    },
  },
};
</script>

<style scoped>
.layout-type-icon {
  display: block;
  width: 16px;
  height: 28px;
}
</style>
